import heartbeat from 'Heartbeat/routes/routes';
import platform from 'Platform/routes/routes';
import settings from 'Settings/routes/routes';
import { assets, ghostwriter, smoc } from './externalRoutes';

const routes = [heartbeat, smoc, assets, ghostwriter, settings, platform];

export const navRoutes = routes.map(({ path, intlMessage, Icon, moduleNameForOrganisationAccess, external }) => ({
  path,
  intlMessage,
  Icon,
  moduleNameForOrganisationAccess,
  external,
}));

export default routes;
